// c61_867 — company scope for the Books code. Provizio is the primary company (the plain
// /books hub). FTMD runs the SAME Books pages at /ftmd against its own database: every API
// call made while an FTMD page is on screen carries `X-Snagger-Company: ftmd` (see
// authInterceptor.js), which the backend turns into that company's database for the request.
//
// The marker is set by the mounted company page (useLayoutEffect) and cleared when it hides —
// workspace tabs keep pages alive but React <Activity hidden> pauses their effects, so only the
// page the operator is looking at owns the marker.
import { createContext, useContext, useLayoutEffect } from "react";

export const COMPANIES = {
  provizio: { id: "provizio", label: "Provizio", path: "/books", header: null, hubId: "books_hub", permission: "books_hub", accent: "indigo", title: "Books Hub" },
  ftmd: { id: "ftmd", label: "FTMD", path: "/ftmd", header: "ftmd", hubId: "ftmd", permission: "ftmd", accent: "amber", title: "FTMD Books" },
  // c61_885 — the owner's personal books: same pages, own data (personal__ collections), owner-only grant
  personal: { id: "personal", label: "Deb's Books", path: "/personal", header: "personal", hubId: "personal", permission: "personal", accent: "emerald", title: "Deb's Books" },
};

let active = null;
export const getActiveCompany = () => active;
export const setActiveCompany = (id) => { active = id && id !== "provizio" ? id : null; };

const CompanyContext = createContext(COMPANIES.provizio);
export const CompanyProvider = ({ company, children }) => (
  <CompanyContext.Provider value={COMPANIES[company] || COMPANIES.provizio}>{children}</CompanyContext.Provider>
);
export const useCompany = () => useContext(CompanyContext);
/** `/books` or `/ftmd` — prefix for every in-hub link */
export const useBooksPath = () => useCompany().path;
export const booksUrl = (base, suffix) => `${base}${suffix.startsWith("?") ? suffix : `/${suffix}`}`;

/** Mounted by the company's page: owns the request marker while visible. */
export const CompanyScope = ({ company }) => {
  useLayoutEffect(() => {
    setActiveCompany(company);
    return () => { if (active === (company === "provizio" ? null : company)) setActiveCompany(null); };
  }, [company]);
  return null;
};

export const companyForPath = (pathname) => {
  const p = String(pathname || "");
  return Object.values(COMPANIES).find((c) => c.id !== "provizio" && (p === c.path || p.startsWith(`${c.path}/`) || p.startsWith(`${c.path}?`)))?.id || "provizio";
};
